import * as React from 'react';

// HORO-10326: chevron-right glyph per Figma 1060:12903 / 935:39724 —
// used both inline next to "View all" (expanded sidebar) and as the
// collapsed stand-in for the same affordance.
const ChevronRightIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={17} height={17} viewBox="0 0 17 17" fill="none" {...props}>
        <path stroke="#FFFFFF" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" d="m6 4 4.5 4.5L6 13" />
    </svg>
);

export default ChevronRightIcon;
